<div class="modal-header">
    <span class="title-heading" translate>File </span>
    <i class="font-size14 title-name-style" *ngIf="createdDetails">- {{ clone?.fileName.length >= 10 ? clone?.fileName.substring(0,10)+"..." :
            clone?.fileName }}</i>
    <i class="font-size14 title-name-style" *ngIf="!createdDetails">- {{ clone?.fileName.length >= 40 ? clone?.fileName.substring(0,40)+"..." :
        clone?.fileName }}</i>
    <span class="right-side font-size14 created-details-style" *ngIf="createdDetails">
        <strong translate>Added </strong>
        <span>{{clone.createdDateTime}}</span>
        <span (click)="attachFileDownload(clone?.fileLocation)">
            <i class="fa fa-download attach-download-icon-size icon-style" aria-hidden="true"></i>
        </span>
        <!-- <a href="{{ pdf_url }}?watermark=0" class="ss-download"  target="_blank"></a> -->
    </span>
</div>
<div class="modal-body" [ngSwitch]="clone.fileGroup">
    <div *ngIf="showTagDropDown">
        <div *access="['TagJobFiles.updateaccess']" >
            <label class="control-label" translate>Tags</label>
            <div class="file-tag-container select2-file-tags">
            <input #select2EditFileTags id="editTagList" type="text" csSelect2 (selected)="selectedTag($event)" [placeholder]="'Add tags'"  [select2Config]="tagsSelect2Config" />
            </div>
        </div>
    </div>
	<span *ngSwitchCase="'image'">
	    <ng-container *ngIf="isPreviewableImage(clone); else unsupportedImagePreview">
            <img class="img-config" [src]="clone?.fileLocation" [attr.data-file-location]="clone?.fileLocation">
	    </ng-container>
	    <ng-template #unsupportedImagePreview>
            <div class="warning-icon-wrap with-info-icon">
                <span class="ss-info icon fix-left"></span>
            </div>
            <div class="warning-message ng-binding text-align-center" translate>
                No.File.Preview.Available
            </div>
	    </ng-template>
	</span>
    <span *ngSwitchCase="'csv'">
        <div class="warning-icon-wrap with-info-icon">
            <span class="ss-info icon fix-left"></span>
        </div>
        <div class="warning-message ng-binding text-align-center" translate>
            No.File.Preview.Available
        </div>
    </span>
    <span *ngSwitchCase="'word_document'">
        <div class="warning-icon-wrap with-info-icon">
            <span class="ss-info icon fix-left"></span>
        </div>
        <div class="warning-message ng-binding text-align-center" translate>
            No.File.Preview.Available
        </div>
    </span>
    <span *ngSwitchCase="'pdf'">
        <ng-container *ngIf="isNoPreviewDocument(clone); else showfile">
            <div class="warning-icon-wrap with-info-icon">
                <span class="ss-info icon fix-left"></span>
            </div>
            <div class="warning-message ng-binding text-align-center" translate>
                No.File.Preview.Available
            </div>
        </ng-container>
        <ng-template #showfile>
		<iframe class="pdf-width" name="{{ clone?.fileName}}" [src]="Url"></iframe>
        </ng-template>
	</span>
    <span *ngSwitchCase="'audio'">
        <audio controls [src]="clone?.fileLocation"></audio>
	</span>
    <span *ngSwitchCase="'video'">
	    <ng-container *ngIf="isPreviewableVideo(clone); else unsupportedVideoPreview">
		    <video class="video-width" controls autoplay loop>
                <source [src]="clone?.fileLocation" [type]="getVideoMimeType(clone)">
            </video>
	    </ng-container>
	    <ng-template #unsupportedVideoPreview>
            <div class="warning-icon-wrap with-info-icon">
                <span class="ss-info icon fix-left"></span>
            </div>
            <div class="warning-message ng-binding text-align-center" translate>
                No.File.Preview.Available
            </div>
	    </ng-template>
	</span>
    <ng-container *ngSwitchDefault>
        <div class="warning-icon-wrap with-info-icon">
            <span class="ss-info icon fix-left"></span>
        </div>
        <div class="warning-message ng-binding text-align-center" translate>
            No.File.Preview.Available
        </div>
    </ng-container>
</div>
<!-- Footer -->
<div class="modal-footer">
    <a class="btn" (click)="bsModalRef.hide()">Close</a>
    <ng-container *ngIf="showTagDropDown">
        <button *access="['TagJobFiles.updateaccess']" type="button" [disabled]="action == 'saving'" class="btn btn-primary" (click)="save()">
            <span *ngIf="action == ''" translate>Save</span>
            <span *ngIf="action == 'saving'" translate>Saving</span>
        </button>
    </ng-container>
    <ng-container *access = "['SendEmail.writeaccess']">
        <button *ngIf="enableEmail" class="btn btn-primary primary-button"  (click)="openSidePanel('email')" translate>Email</button>
    </ng-container>
</div>
